import React from 'react';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-289">
      <div className="max-w-4xl mx-auto text-center" data-id="element-290">
        <h2 className="text-[20px] font-black mb-4 text-[#F9327E]" data-id="element-291">
          La solución: Pack Efemérides Listas
        </h2>

        <p className="text-xl md:text-2xl font-medium text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-292">
          Un recurso completo diseñado para que tengas todo el material del
          calendario escolar organizado durante el año.
          <br data-id="element-293" />
          <br data-id="element-294" />
          Simplemente buscás la fecha que necesitás y el contenido ya está listo
          para trabajar.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-6" data-id="element-295">
          <div className="bg-gray-50 p-4 rounded-xl shadow-sm w-full md:w-1/3 border border-gray-100" data-id="element-296">
            <div className="text-5xl mb-2" data-id="element-297">📅</div>
            <p className="text-xl font-bold" data-id="element-298">Buscás la efeméride</p>
          </div>

          <div className="hidden md:block text-3xl text-gray-300" data-id="element-299">➔</div>

          <div className="bg-gray-50 p-4 rounded-xl shadow-sm w-full md:w-1/3 border border-gray-100" data-id="element-300">
            <div className="text-5xl mb-2" data-id="element-301">📖</div>
            <p className="text-xl font-bold" data-id="element-302">Leés la explicación</p>
          </div>

          <div className="hidden md:block text-3xl text-gray-300" data-id="element-303">➔</div>

          <div className="bg-gray-50 p-4 rounded-xl shadow-sm w-full md:w-1/3 border border-gray-100" data-id="element-304">
            <div className="text-5xl mb-2" data-id="element-305">✏️</div>
            <p className="text-xl font-bold" data-id="element-306">Aplicás la actividad en clase</p>
          </div>
        </div>

        <p className="text-2xl font-black text-gray-900" data-id="element-307">
          <span className="px-2 text-[#3CD0E4] bg-[#FFFFFF]" data-id="element-308">
            Sin perder Tiempo, Sin empezar desde Cero, Sin Improvisar.
          </span>
        </p>
      </div>
    </section>;
}